import { inject, injectable } from "inversify";

import { LogLevel, LogSink } from "./models";
import { AbstractServiceLogger } from "./services";
import LogMux from "./LogMux";
import ConsoleLogger from "./ConsoleLogger";

import Vue from "vue";

declare module "vue/types/vue" {
  interface Vue {
    /**
     * A global error logger added to each vue instance.
     */
    $log: LogSink;
  }
}

@injectable()
export default class VueLogger extends LogMux {
  constructor(
    @inject(AbstractServiceLogger) private serviceLogger: AbstractServiceLogger
  ) {
    super();

    this.registerSink(new ConsoleLogger());
    this.registerSink(this.serviceLogger);
  }

  /**
   * Listener for DOM error events
   *
   * Any error event will be transformed into a string and logged.
   */
  errorListener(error: ErrorEvent) {
    let logString = `An error was emmited in ${error.filename}:${
      error.lineno
    },${error.colno}: ${error.message}.`;
    if (error.error) {
      logString += "\nRelevant object: " + String(error.error);
    }
    this.push("WARN", logString);
  }

  /**
   * Install as vue.js plugin.
   *
   * The plugin provides a $log method on every component.
   */
  install(Vue: { prototype: object }, options: object) {
    const logger = this;
    Object.defineProperty(Vue.prototype, "$log", {
      get() {
        return logger;
      }
    });
  }
}
